export default "__VITE_ASSET__9KCiCRoo__"